<template>
  <div class="mx-a f-col gap-4 items-center md:w-max">
    <p aria-live="polite" class="body-3 c-brand-1">
      {{ replaceAll($t.viewingProducts, { current, total }) }}
    </p>
    <vf-button v-if="current < total" id="viewMoreCTA" @click="$emit('load-more')">
      {{ $t.viewMore }}
    </vf-button>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  current: number
  total: number
}>()

defineEmits<{
  'load-more': []
}>()
</script>
